/**
 * 协调费用相关API服务
 */
import api from './api';
import {
  CoordinationCost,
  CoordinationCostType,
  CreateCoordinationCostData,
  UpdateCoordinationCostData,
  ApiResponse,
  PaginatedResponse,
} from '../types';

// 协调费用统计数据
export interface CoordinationCostStats {
  totalCost: number;
  byType: {
    management: number;
    coordination: number;
    misc: number;
    emergency: number;
  };
  recordCount: number;
}

// 协调费用查询参数
export interface CoordinationCostQueryParams {
  projectId?: string;
  costType?: CoordinationCostType;
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
}

export class CoordinationCostService {
  /**
   * 获取协调费用列表
   */
  static async getCoordinationCosts(
    params: CoordinationCostQueryParams = {}
  ): Promise<PaginatedResponse<CoordinationCost>> {
    return api.get('/coordination-costs', { params }) as Promise<PaginatedResponse<CoordinationCost>>;
  }

  /**
   * 根据ID获取协调费用详情
   */
  static async getCoordinationCostById(id: string): Promise<ApiResponse<CoordinationCost>> {
    return api.get(`/coordination-costs/${id}`) as Promise<ApiResponse<CoordinationCost>>;
  }

  /**
   * 创建协调费用记录
   */
  static async createCoordinationCost(data: CreateCoordinationCostData): Promise<ApiResponse<CoordinationCost>> {
    return api.post('/coordination-costs', data) as Promise<ApiResponse<CoordinationCost>>;
  }

  /**
   * 更新协调费用记录
   */
  static async updateCoordinationCost(
    id: string,
    data: UpdateCoordinationCostData
  ): Promise<ApiResponse<CoordinationCost>> {
    return api.put(`/coordination-costs/${id}`, data) as Promise<ApiResponse<CoordinationCost>>;
  }

  /**
   * 删除协调费用记录
   */
  static async deleteCoordinationCost(id: string): Promise<ApiResponse<void>> {
    return api.delete(`/coordination-costs/${id}`) as Promise<ApiResponse<void>>;
  }

  /**
   * 获取项目协调费用统计
   */
  static async getProjectCoordinationStats(
    projectId: string,
    startDate?: string,
    endDate?: string
  ): Promise<ApiResponse<CoordinationCostStats>> {
    const params: any = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    
    return api.get(`/coordination-costs/stats/${projectId}`, { params }) as Promise<ApiResponse<CoordinationCostStats>>;
  }

  /**
   * 获取协调费用类型标签
   */
  static getCostTypeLabel(type: CoordinationCostType): string {
    const labels: Record<CoordinationCostType, string> = {
      [CoordinationCostType.MANAGEMENT]: '管理费',
      [CoordinationCostType.COORDINATION]: '协调费',
      [CoordinationCostType.MISC]: '杂费',
      [CoordinationCostType.EMERGENCY]: '应急费用',
    };
    return labels[type] || type;
  }

  /**
   * 获取所有协调费用类型选项
   */
  static getCostTypeOptions(): Array<{ value: CoordinationCostType; label: string }> {
    return [
      { value: CoordinationCostType.MANAGEMENT, label: '管理费' },
      { value: CoordinationCostType.COORDINATION, label: '协调费' },
      { value: CoordinationCostType.MISC, label: '杂费' },
      { value: CoordinationCostType.EMERGENCY, label: '应急费用' },
    ];
  }
}
